import { Box, Field, Flex, Input, Text, Textarea } from "@chakra-ui/react";
import React from "react";
import utils from "utils";
import DropDown from "./DropDown";
import SearchInput from "./SearchInput";
import { InputGroup } from "./ui/input-group";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdCalendarMonth } from "react-icons/md";
import { CardRegistration } from "./CardRegistration";

const fs = "sm";

const icCalSvg = <MdCalendarMonth />;
const CustomDateInput = React.forwardRef(
  ({ value, onClick, placeholder, disabled, onChange }, ref) => (
    <InputGroup onClick={onClick} w="100%" endElement={icCalSvg}>
      <Input
        ref={ref}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        pr="2.5rem"
        textStyle={fs}
        w="100%" // updated
        disabled={disabled}
      />
    </InputGroup>
  )
);
CustomDateInput.displayName = "CustomDateInput";

const InputComp = ({
  label,
  value,
  onChange,
  type,
  disabled,
  required,
  placeholder,
  items,
  w,
  keyname,
  maxW,
}) => {
  let typ = type;
  let val = value;
  let requiredVal = required || false;
  let fieldProps = {};

  if (type === "date") {
    if (value) {
      val = utils.dateToDateInput(value);
    } else {
      val = undefined;
    }
  }

  // else if (type === "amt") {
  //   typ = "number";
  //   val = utils.formatCurrency(value);
  // }

  const ipProps = {
    disabled: disabled ?? false,
    value: val,
    type: typ ?? "text",
    // flex="1"
    textStyle: fs,
    placeholder,
    w: "240px",
  };

  const wrpProps = {
    maxW: "22rem",
  };

  ipProps.onChange = (e) => {
    if (type === "vrm-comp") {
      onChange(e);
    } else if (onChange) {
      onChange(e.currentTarget.value);
    }
  };

  if (type === "number-f2") {
    ipProps.type = "number";

    if (typeof val === 'number') {
        ipProps.value = val.toFixed(2);
    } else {
        ipProps.value = val;
    }

    ipProps.onChange = (e) => {
      onChange(e.currentTarget.value);
    };
    ipProps.onBlur = (e) => {
      const value = e.currentTarget.value;
      if (value) {
        onChange(utils.formatNumF2(value));
      }
    };
  }

  if (typ === "date") {
    ipProps.w = "9.5rem";
    // ipProps.alignSelf = 'flex-start';
  }

  if (typ === "dropdown") {
    ipProps.items = items;
    ipProps.onChange = (e) => {
      if (onChange) {
        onChange(e);
      }
    };
    if (w) {
      ipProps.w = w;
    }

    if (!label) {
      fieldProps.unstyled = true;
    }
  }

  if (keyname === "last-filter") {
    ipProps.w = "8rem";
  }

  if (keyname === "claim-state") {
    ipProps.w = "10rem";
  }

  if (keyname === "policy-search") {
    ipProps.bg = "yellow";
  }

  if (typ === "search") {
    ipProps.onChange = onChange;
  }

  // if (keyname === "claims-notify") {
  //   wrpProps.maxW = "100%";
  //   ipProps.w = "100%";
  // }

  if (keyname === "amount") {
    ipProps.w = "8rem";
  }

  if (keyname === "w-100" || w) {
    ipProps.w = "100%";
    wrpProps.maxW = "100%";
  }

  return (
    <Flex {...wrpProps}>
      <Field.Root
        orientation={type === "textarea" ? "vertical" : "horizontal"}
        required={requiredVal}
        {...fieldProps}
      >
        {label ? (
          <Field.Label textStyle={fs}>
            <Text textAlign={"start"}>
              {/* lineClamp={2}> */}
              {label ?? ""}
              {/* {requiredVal ? " " : null} */}
              {requiredVal ? <Field.RequiredIndicator /> : null}
            </Text>
          </Field.Label>
        ) : null}

        {typ === "textarea" ? (
          <Textarea {...ipProps} />
        ) : typ === "dropdown" ? (
          <DropDown {...ipProps} />
        ) : typ === "search" ? (
          <SearchInput {...ipProps} />
        ) : typ === "date" ? (
          <Box w={ipProps.w}>
            <DatePicker
              selected={utils.dateStrToDate(val) || null}
              onChange={(v) => {
                if (!v) {
                  onChange?.(undefined);
                  return;
                }
                const newDate = new Date(
                  Date.UTC(v.getFullYear(), v.getMonth(), v.getDate())
                );
                onChange?.(utils.dateToDateInput(newDate));
              }}
              dateFormat="dd/MM/yyyy"
              customInput={<CustomDateInput disabled={disabled} />}
              portalId="datepicker-portal"
              disabled={disabled}
            />
          </Box>
        ) : typ === "vrm-comp" ? (
          <Flex w={"100%"} justify={"flex-end"}>
            <CardRegistration type={"comp"} {...ipProps} />
          </Flex>
        ) : (
          <Input {...ipProps} />
        )}
        {/* <Flex flex={1} /> */}
      </Field.Root>
    </Flex>
  );

  // return (
  //   <input
  //     type={type}
  //     value={value}
  //     onChange={(e) => onChange(e.currentTarget.value)}
  //   ></input>
  // );
};

export default InputComp;
